<template>
    <v-card elevation="4" tile>
        <div class="primary dark">
            <v-card-title class="white--text">
                SISTEMAS
                <v-spacer/>
                <SistemaModal @saved="params = {}"/>
            </v-card-title>
        </div>
        <v-card-text>
            <SistemaSearch class="mb-4" @search="params = $event"/>
            <SistemaList :params="params"/>
        </v-card-text>
    </v-card>
</template>
<script>
import SistemaList from '@components/entities/comercio/sistema/list';
import SistemaModal from "@components/entities/comercio/sistema/modal";
import SistemaSearch from "@components/entities/comercio/sistema/search";

export default {
    components: {
        SistemaList,
        SistemaModal,
        SistemaSearch
    },
    data: function () {
        return {
            params: {},
        };
    }
}
</script>